<template>
  <section id="banner">
    <div class="setbg-center setbg-cover" style="overflow: hidden;">
      <img
        :src="banner.fileLocation + banner.fileName"
        class="img-setbg"
        alt="網頁插圖"
      />
      <h2 class="text-center text-heading">
        <small>{{ msg }}</small>
      </h2>
    </div>
    <p v-if="show" class="text-center text-collection">
      已募集影像<span>{{ amt }}</span
      >張
    </p>
  </section>
</template>

<script>
import { apiTotal, apiBanner } from '@/api/index'

export default {
  props: ['msg', 'show'],
  data() {
    return {
      banner: {},
      amt: 0,
    }
  },
  methods: {
    bg(src) {
      var e = this.$('.img-setbg')
      e.parent().css('background-image', 'url("' + src + '")')
      e.remove()
    },
    async getContent() {
      await apiBanner().then(response => {
        this.banner = response.data
        this.bg(this.banner.fileLocation + this.banner.fileName)
      })
      if (this.show) {
        await apiTotal().then(response => {
          this.amt = response.data.total
        })
      }
    },
  },
  mounted() {
    this.getContent()
  },
}
</script>
